export const environment = {
  production: true,
  BASE_URL: 'https://api.skill2era.com/api',
  syncfusionLicenseKey:
    'ORg4AjUWIQA/Gnt2XFhhQlJHfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hTH5XdENjXH9Wc3RSTmBbWkZ/',
  keycloak: {
    url: 'https://auth.skill2era.com',
    realm: 'skill2era',
    clientId: 'skill2era-angular',
  },
};
